var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 184,
    viewBox: "0 0 260 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9129 135.068L80.221 175.96C78.9136 180.148 75.0517 182.987 70.6668 182.987H44.0761C39.3091 182.987 35.0449 179.967 33.4961 175.437L1.21312 82.1549C0.147081 79.0945 2.41996 75.9133 5.65832 75.9133H34.0593C37.0362 75.9133 39.651 77.8462 40.536 80.6851L59.4633 140.987C59.946 142.517 62.0982 142.537 62.6212 141.027L77.6464 96.5912L92.933 135.047L92.9129 135.068Z",
    fill: "#333343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.498 6.99378V91.3963L141.287 134.987C140.583 136.014 138.994 135.732 138.672 134.524L134.991 120.732C134.951 120.611 134.951 120.49 134.951 120.349V7.61794C134.951 3.61123 138.19 0.369629 142.192 0.369629H164.901C168.562 0.369629 171.518 3.32936 171.518 6.99378H171.498Z",
    fill: "#333343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.831 55.2556C259.336 55.2556 261.629 60.6717 258.512 63.9133L202.031 122.584L200.382 124.316L178.438 147.108L171.498 154.296L145.028 181.799C144.063 182.806 142.735 183.37 141.347 183.37H122.199C120.107 183.37 118.216 182.081 117.452 180.128L98.4443 131.927L95.9301 125.484V125.443L80.8043 87.1482V87.1079L79.0946 82.7589C77.7671 79.3965 80.2411 75.7724 83.8415 75.7724H110.09C112.283 75.7724 114.234 77.1817 114.938 79.2757L130.888 127.256L134.931 139.457C136.259 143.443 141.529 144.229 143.942 140.806L171.498 101.826L183.064 85.4972L202.896 57.4301C203.862 56.0811 205.411 55.2757 207.06 55.2757H254.831V55.2556Z",
    fill: "#62AF45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.498 163.195V179.242C171.498 181.517 169.648 183.37 167.375 183.37H151.746L171.498 163.195Z",
    fill: "#333343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.846 183.369H212.189C209.051 183.369 206.095 181.94 204.143 179.483L182.36 152.061L204.787 129.148L249.199 178.034C251.049 180.087 249.601 183.369 246.846 183.369Z",
    fill: "#333343"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo-transparent.48cb1bd77d8d0fc4dfba499728ab10cc.svg";
export { ForwardRef as ReactComponent };